import api from "./api";

export interface UserLoginRequest {
  password: string;
  email: string;
}

export interface UserLoginResponse {
  token: string;
}

const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<UserLoginResponse, UserLoginRequest>({
      query: (request) => ({
        url: "auth/login",
        method: "post",
        body: request,
      }),
      invalidatesTags: ["clients", "request", "user"],
    }),
  }),
});

export const { useLoginMutation } = authApi;
export default authApi;
